module.exports = __webpack_public_path__ + "img/shijiazhuangjidi3.1089cc1b.png";